import WelcomeLetterPageContainer from "../../Component/WelcomeLetterPageContainer/WelcomeLetterPageContainer"


const WelcomeLetterPage = () => {
  return (
    <div className='page-body'>
      <WelcomeLetterPageContainer />
    </div>
  )
}

export default WelcomeLetterPage